import { Navigate, useLocation } from "react-router-dom";
import { useBilling } from "@/context/BillingContext";

// Path consentiti anche con account sospeso. Devono coincidere con la whitelist
// del backend in `/app/backend/middleware/billing_lock.py` (eccezioni legali/auth).
const ALLOWED_PATHS = [
  "/app/billing",
  "/app/alloggiati", // adempimento legale TULPS
  "/app/settings",   // diritti GDPR (export/delete account)
];

export default function BillingLockGuard({ children }) {
  const { blocked, loading } = useBilling();
  const location = useLocation();
  if (loading) return children;
  if (!blocked) return children;

  const allowed = ALLOWED_PATHS.some((p) => location.pathname.startsWith(p));
  if (allowed) return children;
  return <Navigate to="/app/billing" replace />;
}
